import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "12",
  height: "12",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.3 7 14.5.9h-1.2L8.8 6.2 5.2.9H1l5.5 7.9L1 15.2h1.2L7 9.7l3.8 5.5H15zM7.6 8.9l-.5-.8-4.4-6.2h1.9L8.2 7l.6.8 4.6 6.6h-1.9z" }, null, -1)
  ])))
}
export default { render: render }